/* eslint-disable @typescript-eslint/naming-convention */
import 'reflect-metadata';
import {FormElement, FormElementConfiguration} from 'app/entities/form/formElement.entity';
import {FileGroupTypes, FormElementFiletView, FormElementType} from 'app/entities/enums';
import {Type} from 'class-transformer';

export class FormElementFile extends FormElement {
  type: FormElementType = 'file';

  @Type(() => FormElementFileConfiguration)
  configuration?: FormElementFileConfiguration = new FormElementFileConfiguration();
}

export class FormElementFileConfiguration extends FormElementConfiguration {
  minFiles?: number = null;
  maxFiles?: number = null;
  maxFileSizeMb?: number = 5;
  view?: FormElementFiletView = 'gallery';
  accepts?: FileGroupTypes[] = ['video', 'image', 'doc'];
  multiple?: boolean = true;
}
